module.exports = __webpack_public_path__ + "static/media/LinkedinIcon.1618540b.png";